<template>
  <div class="print">
    <!-- 1. 헤더 및 결재란 -->
    <section class="section-approval">
      <div class="header-left-area">
        <p class="print-title">{{ $t('AI 안전점검표') }}</p>
        <div class="division-title mt-10">{{ $t('□ 기본정보') }}</div>
      </div>

      <table class="table-approval-field mt-auto">
        <colgroup>
          <col width="38" />
          <col width="112" />
          <col width="112" />
          <col width="112" />
          <col width="112" />
        </colgroup>
        <tr>
          <th rowspan="2" class="gray p-0">
            <div class="flex justify-center items-center">
              <p style="writing-mode: vertical-lr">{{ $i18n.locale === 'ko' ? $t('결&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;재') : $t('결재') }}</p>
            </div>
          </th>
          <th class="gray">{{ $t('작성자') }}</th>
          <th class="gray">{{ $t('검토자') }}</th>
          <th class="gray">{{ $t('회람자') }}</th>
          <th class="gray">{{ $t('승인자') }}</th>
        </tr>
        <tr>
          <td style="vertical-align: middle; height: 80px;">
            <div class="signature-container">
              <img v-if="form.sign1.sign" :src="form.sign1.sign" class="signature-image" />
            </div>
          </td>
          <td style="vertical-align: middle; height: 80px;">
            <div class="signature-container">
              <img v-if="form.sign2.sign" :src="form.sign2.sign" class="signature-image" />
            </div>
          </td>
          <td style="vertical-align: middle; height: 80px;">
            <div class="signature-container">
              <img v-if="form.sign3.sign" :src="form.sign3.sign" class="signature-image" />
            </div>
          </td>
          <td style="vertical-align: middle; height: 80px;">
            <div class="signature-container">
              <img v-if="form.sign4.sign" :src="form.sign4.sign" class="signature-image" />
            </div>
          </td>
        </tr>
      </table>
    </section>

    <!-- 2. 기본/점검 정보 -->
    <section class="section-stdInfo mb-5">
      <table class="w-full">
        <colgroup>
        </colgroup>
        <tr>
          <th>{{ $t('회사명') }}</th>
          <td colspan="3">
            <div class="print-input text-left"> {{ form.stdInfo.field_name }} </div>
          </td>
        </tr>
        <tr>
          <th>{{ $t('공종명') }}</th>
          <td>
            <div class="print-input"> {{ form.inputB_2 }} </div>
          </td>
          <th>{{ $t('작업내용') }}</th>
          <td>
            <div class="print-input"> {{ form.inputB_3 }} </div>
          </td>
        </tr>
        <tr>
          <th>{{ $t('점검자') }}</th>
          <td>
            <div class="print-input"> {{ form.점검자 }} </div>
          </td>
          <th>{{ $t('평가일') }}</th>
          <td>
            <div class="print-input"> {{ form.inputB_4 }} </div>
          </td>
        </tr>
        <tr>
          <th>{{ $t('작성자') }}</th>
          <td>
            <div class="print-input"> {{ form.stdInfo.writer_name }} </div>
          </td>
          <th>{{ $t('작성일') }}</th>
          <td>
            <div class="print-input"> {{ form.stdInfo.date }} </div>
          </td>
        </tr>
      </table>
    </section>

    <!-- 3. 안전점검표 -->
    <section class="section-inspect mb-5">
      <div class="division-title">□ {{ form.inspectTitle }}</div>
      <table class="w-full">
        <colgroup>
          <col />
          <col width="60" />
          <col width="60" />
          <col width="80" />
          <col width="200" />
        </colgroup>
        <thead>
          <tr>
            <th>{{ $t(form.inspectTableHeaderTitle) }}</th>
            <th>{{ $t('양호') }}</th>
            <th>{{ $t('미흡') }}</th>
            <th>{{ $t('해당없음') }}</th>
            <th>{{ $t('비고') }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-if="form.inspectList.length === 0">
            <td colspan="5" class="p-4">{{ $t('작성된 내용이 없습니다.') }}</td>
          </tr>
          <template v-else>
            <template v-for="(item, index) in mergedInspectList">
              <tr v-if="item.isFirst" :key="`title_${index}`">
                <td colspan="5" class="gray font-bold text-left" style="background-color: #f5f5f5;">[ {{ item.title }} ]</td>
              </tr>
              <tr :key="`inspect_${index}`">
                <td class="text-left">{{ item.content }}</td>
                <td><PrintCheckbox :value="item.isChecked === '양호'" class="flex justify-center"/></td>
                <td><PrintCheckbox :value="item.isChecked === '미흡'" class="flex justify-center"/></td>
                <td><PrintCheckbox :value="item.isChecked === '해당없음'" class="flex justify-center"/></td>
                <td class="text-left">{{ item.비고 }}</td>
              </tr>
            </template>
          </template>
        </tbody>
      </table>
    </section>

    <!-- 4. 기타 점검항목 -->
    <section class="section-inspect mb-5" v-if="form.etcList && form.etcList.length > 0">
      <div class="division-title">□ {{ $t('기타 점검항목') }}</div>
      <table class="w-full">
        <colgroup>
          <col />
          <col width="60" />
          <col width="60" />
          <col width="80" />
          <col width="200" />
        </colgroup>
        <thead>
          <tr>
            <th>{{ $t('점검항목') }}</th>
            <th>{{ $t('양호') }}</th>
            <th>{{ $t('미흡') }}</th>
            <th>{{ $t('해당없음') }}</th>
            <th>{{ $t('비고') }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in form.etcList" :key="`etc_${index}`">
            <td class="text-left">{{ item.content }}</td>
            <td><PrintCheckbox :value="item.isChecked === '양호'" class="flex justify-center"/></td>
            <td><PrintCheckbox :value="item.isChecked === '미흡'" class="flex justify-center"/></td>
            <td><PrintCheckbox :value="item.isChecked === '해당없음'" class="flex justify-center"/></td>
            <td class="text-left">{{ item.비고 }}</td>
          </tr>
        </tbody>
      </table>
    </section>

    <!-- 5. 사진대지 -->
    <section class="section-photo" v-if="form.photoList && form.photoList.length > 0">
      <div class="division-title">□ {{ $t('사진대지') }}</div>
      <table class="w-full">
        <colgroup>
          <col width="100" />
          <col/>
        </colgroup>
        <template v-for="photo in form.photoList">
          <tr>
            <td colspan="2" style="height: 650px;">
              <img v-if="photo.path" :src="photo.path" width="100%" height="100%" class="max-w-full w-auto object-contain" />
            </td>
          </tr>
          <tr>
            <td>{{ $t('내용') }}</td>
            <td class="text-left">{{ photo.input }}</td>
          </tr>
        </template>
      </table>
    </section>
  </div>
</template>

<script>
import PrintCheckbox from "@/components/print/PrintCheckbox.vue";

export default {
  name: "Print",
  components: { PrintCheckbox },
  props: {
    isPrint: Boolean,
    board: Object,
    form: Object,
  },
  computed: {
    mergedInspectList() {
      const list = [];
      const groups = {};
      
      this.form.inspectList.forEach((item, index) => {
        if (!groups[item.title]) {
          groups[item.title] = [];
        }
        groups[item.title].push({ ...item, originalIndex: index });
      });

      Object.keys(groups).forEach(title => {
        const groupItems = groups[title];
        groupItems.forEach((item, i) => {
          list.push({
            ...item,
            isFirst: i === 0,
            rowspan: groupItems.length
          });
        });
      });
      
      return list;
    }
  }
};
</script>

<style lang="scss" scoped>
.print {

  .signature-container {
    width: 100%;
    height: 100px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 10px;

    .signature-image {
      width: auto;
      height: auto;
      max-width: 100%;
      max-height: 80px;
      object-fit: contain;
      display: block;
    }
  }

  /* 테이블 공통 */
  table {
    table-layout: fixed;
    border-collapse: collapse;
    width: 100%;

    th, td {
      border: 1px solid #757575;
      text-align: center;
      font-size: 18px;
      word-break: break-word;
      white-space: normal;
    }
    th {
      background-color: #ececec;
      font-weight: 500;
      padding: 1.5rem 0;
    }
    td {
      word-break: keep-all;
      img {
        display: inline-block;
      }
    }
    .gray {
      background-color: #ececec;
    }
    .text-left {
      text-align: left;
      padding: 10px 14px;
    }
  }

  /* 헤더/결재란 */
  .section-approval {
    display: grid;
    grid-template-columns: 1fr auto;
    width: 100%;
    align-items: flex-start;

    .header-left-area {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      height: 100%;
      padding-top: 20px;

      .print-title {
        font-size: 32px;
        font-weight: bold;
        color: #000;
        text-align: center;
        white-space: nowrap;
        margin-bottom: 20px;
      }
    }

    .table-approval-field {
      width: auto;
      margin-left: 10px;

      th { width: 112px; padding: 10px 14px; height: 38px; }
      th:first-child { width: 38px; padding: 0; }
      td { height: 80px; }

      tr:last-child {
        th, td { border-bottom: none !important; } // 하단 테두리 제거 (다음 테이블과 밀착)
      }
    }
  }

  .division-title {
    font-size: 24px;
    font-weight: bold;
    color: #3C3C3C;
    padding: 1.25rem 0rem;
    white-space: nowrap;
  }

  /* 테이블 간 간격 제어 */
  table {
    margin-bottom: 20px; // 간격 축소
  }

  .section-approval table {
    margin-bottom: 0; // 헤더 부분은 밀착
  }

  /* 기본정보 */
  .section-stdInfo {
    th { width: 140px; }
    td div { border: none; }
  }

  /* 사진대지 */
  .section-photo {
    td { padding: 1rem; }
  }
}

@media print {
  .page-break {
    page-break-inside: avoid;
    page-break-after: auto;
  }
  /* 테이블 행이 잘리지 않도록 설정 (필요시) */
  tr {
    page-break-inside: avoid;
    page-break-after: auto;
  }
}
</style>
